import { useTheme } from '@/hooks/useTheme'

// No listener needed: an explicit Light/Dark choice resolves synchronously, and "system"
// re-reads matchMedia on every render — same value ThemeProvider itself would apply.
export function useIsDarkMode(): boolean {
  const { preference } = useTheme()
  if (preference === 'dark') return true
  if (preference === 'light') return false
  return window.matchMedia('(prefers-color-scheme: dark)').matches
}
